import { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import styles from '../PropertyPanel.module.css';

function TagsField({ label, value = [], onChange }) {
  const [inputValue, setInputValue] = useState('');
  const tags = Array.isArray(value) ? value : [];

  const addTag = (tag) => {
    const trimmed = tag.trim();
    if (trimmed && !tags.includes(trimmed)) {
      onChange([...tags, trimmed]);
    }
  };

  const removeTag = (index) => {
    onChange(tags.filter((_, i) => i !== index));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      addTag(inputValue);
      setInputValue('');
    }
    if (e.key === 'Backspace' && !inputValue && tags.length > 0) {
      removeTag(tags.length - 1);
    }
  };

  return (
    <div className={styles.field}>
      <span className={styles.fieldLabel}>{label}</span>
      <div className={styles.tagsContainer}>
        {tags.map((tag, i) => (
          <span key={i} className={styles.tagChip}>
            {tag}
            <button className={styles.tagRemove} onClick={() => removeTag(i)}>
              <FaTimes />
            </button>
          </span>
        ))}
        <input
          type="text"
          className={styles.tagInput}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={tags.length === 0 ? 'Type and press Enter' : ''}
        />
      </div>
    </div>
  );
}

export default TagsField;
